import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    'tooltip'
  ]

  open() {
    this.tooltipTarget.classList.remove('hidden');
  }

  close() {
    this.tooltipTarget.classList.add('hidden');
  }

  noop(e) {
    e.stopPropagation();
  }
}